import { graphql } from '@/generated/gql';

export const DEMAND_PROCESS_STEPS_UPDATE_SUBSCRIPTION = graphql(/* GraphQL */ `
  subscription DemandProcessStepsUpdate {
    tesseract {
      demandProcessStepsUpdate {
        id
      }
    }
  }
`);
